// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Image, Input, Button } from 'semantic-ui-react';
// local
import { login } from 'app/redux/actions/auth';
// image
import logo from 'app/_assets/img/salvusatas_logo_login.png';
// css
import './Login.scss';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = { email: '', password: '' };
    }

    // On change the input's update the component state.
    onChange = (e, { name, value }) => this.setState({ [name]: value });

    // On submit the form.
    onSubmit = () => this.props.dispatch(login(this.state.email, this.state.password));

    onKeyDown = e => {
        // 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            this.onSubmit();
        }
    };

    render() {
        const { loading, error } = this.props.auth;
        return (
            <div id="page-login">
                <div id="backdrop-cylinder" />
                <div id="form">
                    <div id="form-wrapper">
                        <Image src={logo} className="img-logo" />
                        <div className="txt-logo">
                            ATAS{' '}
                            <span className="o2">
                                O<sub>2</sub>
                            </span>
                        </div>
                        {error && <div className="txt-error">Os dados informados estão incorretos. Tente novamente.</div>}
                        <Input placeholder="login" name="email" className="input-login" type="email" onChange={this.onChange} onKeyDown={this.onKeyDown} />
                        <Input
                            placeholder="senha"
                            name="password"
                            className="input-password"
                            type="password"
                            onChange={this.onChange}
                            onKeyDown={this.onKeyDown}
                        />
                        <Button content="Entrar" className="btn-login" onClick={this.onSubmit} loading={loading} type="submit" />
                    </div>
                </div>
            </div>
        );
    }
}

Login.propTypes = {
    auth: PropTypes.object,
    dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
    auth: state.auth,
});
export default connect(mapStateToProps)(Login);
